import React from 'react'
import { Link, useParams } from 'react-router-dom'
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import blog from '../assets/images/hero/slide1.jpg'
import DrSidebars from '../components/dr-sidebar'
import Tecnologiamini from '../components/tecnologiamini'
import { useState, useEffect } from 'react';
import { translateDayOfTheWeek } from '../utils/utils';
import { FiCheckCircle } from "react-icons/fi";
import Blogmini from '../components/blogmini'
import Serviciosmini from '../components/serviciosmini'
import { LuFileBadge, LuFileBadge2 } from 'react-icons/lu'
import { decryptData } from '../utils/crypt'
import useCsrfToken from '../hooks/useCsrfToken'
import sanitizeHtml from 'sanitize-html'
import { Helmet } from 'react-helmet-async'

export default function DirectorioDetalle() {
	const { csrfToken } = useCsrfToken();
	const { slug } = useParams();
	const [doctor, setDoctor] = useState([]);
	let [activeImage, setImage] = useState('');
	const API_URL = process.env.REACT_APP_API_URL;
	const handleImageChange = (index) => {
		const images = document.querySelectorAll('.gallerimage');
		images.forEach((img, imgIndex) => {
			img.classList.remove('fade-in');
			img.classList.add('fade-out');
			setTimeout(() => {
				setImage(API_URL + doctor.gallerylarge[index].url_large)
				img.classList.add('fade-in');
				img.classList.remove('fade-out');
			}, 500);
		});
	}
	const stripAllTagsFromHtml = (html) => {
		return sanitizeHtml(html, {
			allowedTags: []
		});
	};

	useEffect(() => {
		const secretKey = process.env.REACT_APP_ENCRYPTION_KEY;
		const domesticDecryptdata = (data) => {
			return decryptData(data, secretKey);
		};
		const stripTagsFromHtml = (html) => {
			const allowedTags = ['b', 'u', 'i', 'p', 'br', 'span', 'strong', 'em', 'a'];
			return sanitizeHtml(html, {
				allowedTags: allowedTags
			});
		};
		const transformData = (data) => {
			const preloadImages = (images) => {
				images.forEach(image => {
					const img = new Image();
					img.src = `${API_URL}${image.url_large}`;
				});
			};

			if (data.gallery?.galleryimages) {
				preloadImages(data.gallery.galleryimages);
			}
			return ({
				id: data.id,
				encrid: data.encrid,
				image: `${API_URL}${data.primary_image}`,
				title: data.title,
				slug: data.slug,
				listing_type: data.listing_type,
				status: data.status,
				visibility: data.visibility,
				user_id: data.user_id,
				specialty_id: data.specialty_id,
				subspecialty_id: data.subspecialty_id,
				license: data.license,
				subspecialty_license: data.subspecialty_license,
				bio: data.bio !== '' ? stripTagsFromHtml(data.bio) : '',
				office: data.office,
				phone_1: data.phone_1 !== null ? domesticDecryptdata(data.phone_1) : '',
				phone_2: data.phone_2 !== null ? domesticDecryptdata(data.phone_2) : '',
				terms: data.terms,
				schedules: data.schedules,
				is_package: data.is_package,
				is_purchaseable: data.is_purchaseable,
				service_duration: data.service_duration,
				payment_methods: data.payment_methods,
				default_contact_email: data.default_contact_email !== null ? domesticDecryptdata(data.default_contact_email) : '',
				specialty_title: data.specialty_title,
				subspecialty_title: data.subspecialty_title,
				cta_url: data.cta_url,
				gallery: data.gallery?.gallerythumbs,
				gallerylarge: data.gallery?.galleryimages,
				tags: data.tags,
				branches: data.branches,
				embed: data.embed,
				searchspecialties: data.searchspecialties,
			});
		};
		if (csrfToken != null) {
			fetch(`${API_URL}/api/listing/${slug}`, {
				method: 'GET',
				credentials: 'include',
				headers: {
					'X-CSRF-TOKEN': csrfToken,
					'Content-Type': 'application/json',
					'Accept': 'application/json',
				}
			}).then(response => response.json())
				.then(data => {
					setDoctor(transformData(data));
					setImage(API_URL + data.gallery?.galleryimages[0].url_large);
				})
				.catch(error => console.error('Error fetching data:', error));
		}
	}, [API_URL, slug, csrfToken]);
	const basedomain = process.env.REACT_APP_BASE_URL;
	return (
		<>
			<Helmet>
				<title>{`${doctor.title} | ${doctor.specialty_title} | Directorio médico Hospital Aranda de La Parra `}</title>
				<meta name="description" content={`${stripAllTagsFromHtml(doctor.intro)}`} />
				<meta property="og:title" content={`${doctor.title} | ${doctor.specialty_title} | Directorio médico Hospital Aranda de La Parra `} />
				<meta property="og:description" content={`${stripAllTagsFromHtml(doctor.intro)}`} />
				<meta property="og:image" content={`${doctor.image}`} />
				<meta property="og:url" content={`${basedomain}/directorio/${doctor.slug}`} />
				<meta property="og:type" content="website" />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:title" content={`${doctor.title} | ${doctor.specialty_title} | Directorio médico Hospital Aranda de La Parra `} />
				<meta name="twitter:description" content={`${stripAllTagsFromHtml(doctor.intro)}`} />
				<meta name="twitter:image" content={`${doctor.image}`} />
				<meta itemprop="name" content={`${doctor.title} | ${doctor.specialty_title} | Directorio médico Hospital Aranda de La Parra `} />
				<meta itemprop="description" content={`${stripAllTagsFromHtml(doctor.intro)}`} />
				<meta itemprop="image" content={`${doctor.image}`} />
			</Helmet>
			<Navbar />

			<section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${blog})`, backgroundPosition: 'center' }}>
				<div className="bg-overlay bg-gradient-overlay"></div>
				<div className="container">
					<div className="row mt-5 justify-content-center">
						<div className="col-12">
							<div className="title-heading text-center">
								<h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark mt-4">
									{doctor.title}
								</h5>
								<p className='text-light'>
									{doctor.specialty_title}
								</p>
							</div>
						</div>
					</div>

					<div className="position-middle-bottom">
						<nav aria-label="breadcrumb" className="d-block">
							<ul className="breadcrumb breadcrumb-muted mb-0 p-0">
								<li className="breadcrumb-item"><Link to="/">Home</Link></li>
								<li className="breadcrumb-item active" aria-current="page"><Link to="/directorio">Directorio</Link></li>
								<li className="breadcrumb-item active" aria-current="page">{doctor.title}</li>
							</ul>
						</nav>
					</div>
				</div>
			</section>
			<div className="position-relative">
				<div className="shape overflow-hidden text-white">
					<svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
					</svg>
				</div>
			</div>

			<section className="section">
				<div className="container">
					<div className="row">
						{doctor.title != null ? (
							<>
								<div className="col-lg-4 col-md-5 col-12 mt-4 pt-2 mt-md-0 pt-md-0 d-block d-md-none">
									<DrSidebars email={doctor.default_contact_email} image={doctor.image} phone1={doctor.phone_1} phone2={doctor.phone_2} ctaurl={doctor.cta_url} ctaicon={doctor.cta_icon} />
								</div>

								<div className="col-lg-8 col-md-7">
									<div className="card border-0 shadow rounded overflow-hidden">

										<div className="card-body">
											<div>
												<h1 className='pb-1 mb-0 text-primary text-center'>{doctor.title}</h1>
												<div className='text-lg text-center'>
													<strong>
														{doctor.specialty_title}
													</strong>
													{doctor.license && (
														<div>
															{' '} <LuFileBadge size={'20px'} /> {doctor.license}
														</div>
													)}
													<br />
													<strong className='text-secondary'>{doctor.subspecialty_title}</strong>
													{doctor.subspecialty_license && (
														<div className='text-secondary'>
															{' '} <LuFileBadge2 size={'20px'} color='#597AF6' /> {doctor.subspecialty_license}
														</div>
													)}
												</div>
											</div>
											<div>
												<h4 className='pb-1 mb-0 mt-3 text-primary text-center'>Otras especialidades</h4>
												<div className='text-lg text-center'>
													{doctor.searchspecialties && doctor.searchspecialties.map((item, index) => (
														<span key={index} to="#" className="badge badge-link me-1 bg-lightergray">
															{item.title} (#{item.license})
														</span>
													))}
													{/* <table className="table table-bordered mt-4">
														<thead>
															<tr>
																<th>Especialidad</th>
																<th>No. Cédula</th>
															</tr>
														</thead>
														<tbody>
															{doctor.searchspecialties && doctor.searchspecialties.map((item, index) => (
																<tr key={index}>
																	<td>
																		{item.title}
																	</td>
																	<td>
																		{item.license}
																	</td>
																</tr>
															))}
														</tbody>
													</table> */}
												</div>
											</div>
											<div className="text-muted mt-5" dangerouslySetInnerHTML={{ __html: doctor.bio }} />
											<table className="table table-bordered mt-4">
												<thead>
													<tr>
														<th>Día</th>
														<th>Horario</th>
													</tr>
												</thead>
												<tbody>
													{doctor.schedules && Object.keys(JSON.parse(doctor.schedules)).length > 0 ? (
														Object.entries(JSON.parse(doctor.schedules)).map(([day, schedule], index) => (
															schedule.status === "on" && (
																<tr key={index}>
																	<td>{translateDayOfTheWeek(day)}</td>
																	<td>
																		{[schedule.time1, schedule.time2, schedule.time3, schedule.time4]
																			.filter(Boolean)
																			.map((time, i, arr) => {
																				if (i === 1 && arr[2]) {
																					return `${time} y ${arr[2]} a ${arr[3]}`;
																				}
																				if (i > 1) return null;
																				return time;
																			})
																			.filter(Boolean)
																			.join(' a ')}
																	</td>
																</tr>
															)
														))
													) : (
														<tr>
															<td colSpan="2" className="text-center">No hay horarios disponibles</td>
														</tr>
													)}
												</tbody>
											</table>
											<table className="table table-bordered mt-4">
												<thead>
													<tr>
														<th colSpan={doctor.payment_methods && Object.keys(JSON.parse(doctor.payment_methods)).length}>
															Métodos de pago admitidos
														</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														{doctor.payment_methods && Object.keys(JSON.parse(doctor.payment_methods)).length > 0 ? (
															Object.entries(JSON.parse(doctor.payment_methods)).map(([method, available], index) => (
																<td key={index}><FiCheckCircle /> {method.charAt(0).toUpperCase() + method.slice(1)}</td>
															))
														) : (
															<td className="text-center">No hay métodos de pago disponibles</td>
														)}
													</tr>
												</tbody>
											</table>
											<table className="table table-bordered mt-4">
												<thead>
													<tr>
														<th colSpan={2}>
															Datos adicionales
														</th>
													</tr>
												</thead>
												<tbody>
													{doctor.service_duration && (
														<tr>
															<td className='text-start w-50'>
																Duración del servicio
															</td>
															<td>
																{doctor.service_duration}
															</td>
														</tr>
													)}
													{doctor.office && (
														<tr>
															<td className='text-start w-50'>
																Consultorio
															</td>
															<td>
																{doctor.office}
															</td>
														</tr>
													)}
												</tbody>
											</table>
											<br />
											<h5 className='fw-bold mt-3'>Disponible en:<br />
												{doctor.branches && doctor.branches.map((item, index) => (
													<span key={index} to="#" className="badge badge-link me-1 bg-lightgray">
														{item.title}
													</span>
												))}
											</h5>
											<br />
											{doctor.tags && doctor.tags.map((item, index) => (
												<Link key={index} to="#" className="badge badge-link me-1" style={{ backgroundColor: item.color }}>
													{item.title}
												</Link>
											))}
											{doctor.gallery && (
												<>
													<h3 className='mt-4'>Galería</h3>
													<img src={activeImage ? activeImage : doctor.image} className="img-fluid galMainImage w-100 gallerimage" alt="" />
													<div className="row mt-4">
														{doctor.gallery && doctor.gallery.map((item, index) => (
															<div key={index} className="col-4 col-md-2">
																<Link onClick={() => handleImageChange(index)}>
																	<img src={API_URL + item.url_thumbnail} alt="Galería" className='img-fluid' />
																</Link>
															</div>
														))}
													</div>
												</>
											)}

											{doctor.embed && doctor.embed.includes('<') && (
												<div className="text-center mt-5 position-relative" dangerouslySetInnerHTML={{ __html: doctor.embed }} />
											)}
										</div>
									</div>
								</div>

								<div className="col-lg-4 col-md-5 col-12 mt-4 pt-2 mt-md-0 pt-md-0 d-none d-md-block">
									<DrSidebars email={doctor.default_contact_email} image={doctor.image} phone1={doctor.phone_1} phone2={doctor.phone_2} ctaurl={doctor.cta_url} ctaicon={doctor.cta_icon} />
								</div>
							</>
						) : (
							<div className="col-12 text-center">
								Cargando...
							</div>
						)}

					</div>
				</div>
			</section>
			<Tecnologiamini listingid={doctor.encrid} bgmode='bg-inverted' />
			<Serviciosmini listingid={doctor.encrid} />
			<Blogmini listingid={doctor.encrid} bgmode='bg-inverted' />
			<Footer />
			<ScrollToTop />
		</>
	)
}
